module.exports = __webpack_public_path__ + "statics/img/2-7.9c70dab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/2-7.png
// module id = 3c2C
// module chunks = 1